// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__t1nkS","left":"InfoRow_left__33z7l"};